// AI Generated
import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { MonDialog } from '@client/app/modules/dialog-upgrade-wrapper/mon-dialog.service';

@Component({
    selector: 'form-global-policy-pre-content',
    standalone: false,
    template: `
        <div class="form-global-policy-pre-content">
            <form #form="ngForm"
                  class="form-horizontal"
                  (ngSubmit)="form.valid && close()">
                <div class="mon-dialog-header">
                    <page-header [header]="'New policy' | translate">
                    </page-header>
                </div>
                <div class="mon-dialog-body-with-footer inner-t-medium">
                    @switch (template.pre_content_component) {
                        @case ('form-global-policy-pre-content-rule-max-length') {
                            <form-global-policy-pre-content-rule-max-length [model]="ngModel" />
                        }
                        @case ('form-global-policy-pre-content-rule-missing-company-name') {
                            <form-global-policy-pre-content-rule-missing-company-name [model]="ngModel" />
                        }
                        @case ('form-global-policy-pre-content-rule-missing-trademark') {
                            <form-global-policy-pre-content-rule-missing-trademark [model]="ngModel" />
                        }
                        @case ('form-global-policy-pre-content-rule-repeated-short-words') {
                            <form-global-policy-pre-content-rule-repeated-short-words [model]="ngModel" />
                        }
                        @case ('form-global-policy-pre-content-rule-without-context') {
                            <form-global-policy-pre-content-rule-without-context [model]="ngModel" />
                        }
                        @default {
                        }
                    }
                    <div [innerHTML]="component"></div>
                </div>
                <div class="mon-dialog-footer text-right">
                    <button type="submit"
                            class="btn btn-border-radius btn-secondary"
                            [disabled]="!form.valid"
                            translate>
                        Save
                    </button>
                </div>
            </form>
        </div>
    `,
})
export class FormGlobalPolicyPreContentComponent implements OnInit {
    @Input() template: any;
    @Input() monDialogId?: string;

    ngModel: any = null;
    component: SafeHtml = '';
    form: any = { valid: true };

    constructor (
        private monDialog: MonDialog,
        private sanitizer: DomSanitizer,
    ) {}

    ngOnInit (): void {
        this.activate();
    }

    private activate (): void {
        this.ngModel = null;

        this.component = this.sanitizer.bypassSecurityTrustHtml(
            '<' + this.template.pre_content_component + '></' + this.template.pre_content_component + '>',
        );
    }

    close (): void {
        this.monDialog.close(this.monDialogId, this.ngModel);
    }
}
